'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

/**
 * 상품 옵션 조회 — 옵션 시트에서 (color/size) → goodsOptionNo(SKU) 해석에 사용.
 * goodsNos 가 비어 있으면 조회하지 않는다.
 */
export const useSeedingProductOptions = (campaignId: number | undefined, goodsNos: number[]) =>
  useQuery({
    ...curatorQueries.campaigns.seedingProductOptions({ campaignId: campaignId!, goodsNos }),
    enabled: campaignId !== undefined && campaignId > 0 && goodsNos.length > 0,
  });
